/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Stats_SourceInputs */

const en_landing_stats_source = /** @type {(inputs: Landing_Stats_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platform capabilities as of March 2026. For current AI processing and hosting provider details, see our Privacy Policy (/privacy).`)
};

const de_landing_stats_source = /** @type {(inputs: Landing_Stats_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plattform-Funktionen, Stand Maerz 2026. Aktuelle Informationen zu KI- und Hosting-Anbietern unter /privacy.`)
};

const fr_landing_stats_source = /** @type {(inputs: Landing_Stats_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fonctionnalites de la plateforme, mars 2026. Pour les details actuels sur les fournisseurs IA et d'hebergement, voir /privacy.`)
};

const es_landing_stats_source = /** @type {(inputs: Landing_Stats_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funcionalidades de la plataforma a marzo de 2026. Para detalles actuales de proveedor de IA y alojamiento, ver /privacy.`)
};

const it_landing_stats_source = /** @type {(inputs: Landing_Stats_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funzionalita della piattaforma a marzo 2026. Per i dettagli attuali su fornitore IA e hosting, vedere /privacy.`)
};

const nl_landing_stats_source = /** @type {(inputs: Landing_Stats_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platformmogelijkheden per maart 2026. Voor actuele details over AI-verwerking en hosting-aanbieder, zie /privacy.`)
};

const pl_landing_stats_source = /** @type {(inputs: Landing_Stats_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mozliwosci platformy na marzec 2026. Aktualne informacje o dostawcy AI i hostingu: /privacy.`)
};

const fi_landing_stats_source = /** @type {(inputs: Landing_Stats_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alustan ominaisuudet maaliskuussa 2026. Ajantasaiset tiedot tekoaely- ja isannointipalveluntarjoajista: /privacy.`)
};

const da_landing_stats_source = /** @type {(inputs: Landing_Stats_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platformens funktioner pr. marts 2026. For aktuelle oplysninger om AI-behandling og hostingudbyder, se /privacy.`)
};

const sv_landing_stats_source = /** @type {(inputs: Landing_Stats_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plattformens funktioner per mars 2026. For aktuell information om AI-behandling och hostingleverantor, se /privacy.`)
};

/**
* | output |
* | --- |
* | "Platform capabilities as of March 2026. For current AI processing and hosting provider details, see our Privacy Policy (/privacy)." |
*
* @param {Landing_Stats_SourceInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_stats_source = /** @type {((inputs?: Landing_Stats_SourceInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Stats_SourceInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_stats_source(inputs)
	if (locale === "fr") return fr_landing_stats_source(inputs)
	if (locale === "es") return es_landing_stats_source(inputs)
	if (locale === "it") return it_landing_stats_source(inputs)
	if (locale === "nl") return nl_landing_stats_source(inputs)
	if (locale === "pl") return pl_landing_stats_source(inputs)
	if (locale === "fi") return fi_landing_stats_source(inputs)
	if (locale === "da") return da_landing_stats_source(inputs)
	if (locale === "sv") return sv_landing_stats_source(inputs)
	return en_landing_stats_source(inputs)
});